import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Users, Building2, Package } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const RegisterChoice = () => {
  const navigate = useNavigate();

  // B2B Only - Auto redirect to business registration
  useEffect(() => {
    // Auto-redirect to business registration after showing splash
    const timer = setTimeout(() => {
      navigate('/register/business');
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-purple-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-100 rounded-full mb-4">
              <Building2 className="w-10 h-10 text-purple-600" />
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">
              Registrazione Partner Commerciale
            </h2>
            <p className="text-lg text-gray-600">
              IlTuoAmaro.it è ora una piattaforma B2B dedicata ai professionisti
            </p>
          </div>

          {/* B2B Benefits */}
          <div className="space-y-4 mb-8">
            <div className="flex items-start p-4 bg-purple-50 rounded-lg">
              <Package className="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900">Forniture All'Ingrosso</h3>
                <p className="text-sm text-gray-600">Ordine minimo 24 bottiglie con sconti progressivi</p>
              </div>
            </div>
            <div className="flex items-start p-4 bg-purple-50 rounded-lg">
              <Users className="w-6 h-6 text-purple-600 mr-3 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-gray-900">Listino Riservato</h3>
                <p className="text-sm text-gray-600">Prezzi all'ingrosso dedicati ai partner professionali</p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <p className="text-sm text-gray-500 mb-4">
              Reindirizzamento alla registrazione business...
            </p>
            <Link
              to="/register/business"
              className="inline-flex items-center px-8 py-4 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition-all transform hover:scale-105 shadow-lg"
            >
              <Users className="w-5 h-5 mr-2" />
              Registrati Ora
            </Link>
          </div>

          <div className="text-center mt-8 pt-8 border-t border-gray-200">
            <span className="text-sm text-gray-600">
              Hai già un account?{' '}
              <Link to="/login" className="font-medium text-purple-600 hover:text-purple-500">
                Accedi qui
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterChoice;